import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface OtpFooterProps {
  allowedResendCount: number;
  handleResend: () => void;
  isDisabled: boolean;
}

const ACTION_BASE_CLASSNAME = "cursor-pointer underline hover:text-slate-700";
const ACTION_DISABLED_CLASSNAME =
  "disabled:cursor-not-allowed disabled:opacity-50";

export const OtpFooter = ({
  handleResend,
  isDisabled,
  allowedResendCount,
}: OtpFooterProps) => {
  const [resendCount, setResendCount] = useState(0);

  const handleResendClick = () => {
    setResendCount(prev => prev + 1);
    handleResend();
  };

  const shouldShowResendButton = resendCount < allowedResendCount;

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between">
        {shouldShowResendButton ? (
          <button
            type="button"
            className={classNames(
              ACTION_BASE_CLASSNAME,
              ACTION_DISABLED_CLASSNAME,
            )}
            onClick={handleResendClick}
            disabled={isDisabled}
          >
            <Typography.BodySm color="text-slate-900 dark:text-inherit">
              {t("otp_challenge_modal.resend_code")}
            </Typography.BodySm>
          </button>
        ) : (
          <a
            href={t("otp_challenge_modal.experiencing_issues.link")}
            target="_blank"
            rel="noopener noreferrer"
            className={ACTION_BASE_CLASSNAME}
            aria-label={t(
              "otp_challenge_modal.experiencing_issues.link_aria_label",
            )}
          >
            <Typography.BodySm color="text-slate-900 dark:text-inherit">
              {t("otp_challenge_modal.experiencing_issues.link_text")}
            </Typography.BodySm>
          </a>
        )}
        <div className="border-primary flex items-center gap-1 rounded-lg border px-2 py-1">
          <Icon type="16-lock" size={16} className="text-tertiary size-4" />
          <span className="leading-[18px] tracking-[0.2px]">
            <Typography.LabelXs color="text-tertiary" weight="font-medium">
              {t("otp_challenge_modal.safe_and_secure")}
            </Typography.LabelXs>
          </span>
        </div>
      </div>
    </div>
  );
};

OtpFooter.displayName = "OtpFooter";
